import { translate } from "app/filters/i18nFilter";
import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import Card from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/Card";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";
import DigitalAssetsRoot from "app/pages/sales-intelligence/pages/company-analysis/containers/digital-assets/DigitalAssetsRoot/DigitalAssetsRoot";

const DigitalAssetsRootWithErrorBoundary = () => {
    return (
        <ErrorBoundaryWithLogging
            fallback={
                <Card
                    dataAutomation="digital-assets-card"
                    isEmpty
                    header={
                        <CardHeader
                            title={translate("si.company-analysis.digital-assets.card.header")}
                            infoTooltip={translate("si.company-analysis.digital-assets.card.header.tooltip")}
                        />
                    }
                    renderContent={() => null}
                />
            }
        >
            <DigitalAssetsRoot />
        </ErrorBoundaryWithLogging>
    );
};

export default DigitalAssetsRootWithErrorBoundary;
